/**
 * 시간 포맷 상수
 * @module core/time/constants
 */

/** Live 모드 시간 표시 포맷 (예: 2024.01.15 14:30:25) */
export const GLOBAL_TIME_LIVE_FORMAT = 'YYYY.MM.DD HH:mm:ss';

/** Range 모드 시간 표시 포맷 (예: 24.01.15 14:30:25) */
export const GLOBAL_TIME_RANGE_FORMAT = 'YY.MM.DD HH:mm:ss';

/** 분 단위 시간 표시 포맷 (예: 2024.01.15 14:30) */
export const GLOBAL_TIME_MINUTE_FORMAT = 'YYYY.MM.DD HH:mm';

/** UTC 시간 포맷 */
export const UTC_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/** UTC 시간 포맷 (밀리초 포함) */
export const UTC_TIME_FORMAT_MILLISECOND = 'YYYY-MM-DD HH:mm:ss.SSS';

/** 최소 허용 날짜/시간 */
export const MIN_DATE_TIME = '1990-01-01 00:00:00';

/** UTC 날짜 포맷 */
export const UTC_DATE_FORMAT = 'YYYY-MM-DD';

/** 캘린더 시간 포맷 */
export const GLOBAL_DATE_FORMAT = 'YYYY.MM.DD';
